import React, { useState, useEffect } from 'react';
import { apiFetch } from './api';

const FIELDS = [
  { key: 'membership_count',       label: 'Membership Count',   step: 1,    min: 0 },
  { key: 'pmpm',                   label: 'PMPM ($)',           step: 0.01, min: 0 },
  { key: 'specialty_pmpm',         label: 'Specialty PMPM ($)', step: 0.01, min: 0 },
  { key: 'opportunity_percentage', label: 'Opportunity (%)',    step: 0.1,  min: 0 },
  { key: 'realized_percentage',   label: 'Realized (%)',       step: 0.1,  min: 0 },
  { key: 'total_utilization',      label: 'Total Utilization',  step: 0.1,  min: 0 },
];

export default function SettingsModal({ onClose }) {
  const [form, setForm]       = useState(null);
  const [error, setError]     = useState('');
  const [saving, setSaving]   = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    apiFetch('/api/dashboards/intelligence-config')
      .then(r => r.json())
      .then(setForm)
      .catch(() => setError('Unable to load current settings.'));
  }, []);

  const set = key => e => setForm(f => ({ ...f, [key]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      const body = Object.fromEntries(FIELDS.map(f => [f.key, parseFloat(form[f.key])]));
      const res = await apiFetch('/api/dashboards/intelligence-config', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      if (res.status === 204) {
        setSuccess(true);
        setTimeout(onClose, 500);
      } else {
        const data = await res.json().catch(() => ({}));
        setError(data.detail || 'An error occurred. Please try again.');
      }
    } catch {
      setError('Unable to reach the server.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="cpw-backdrop">
      <div className="cpw-card">
        <div className="cpw-header">Dashboard Settings</div>
        <div className="cpw-body">
          {success && (
            <div className="alert alert-success py-2 mb-3" style={{ fontSize: '0.875rem' }}>
              Settings saved.
            </div>
          )}
          {error && (
            <div className="alert alert-danger py-2 mb-3" style={{ fontSize: '0.875rem' }}>{error}</div>
          )}
          {!form && !error && (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status" />
            </div>
          )}
          {form && (
            <form onSubmit={handleSubmit}>
              {FIELDS.map(({ key, label, step, min }) => (
                <div className="mb-3" key={key}>
                  <label className="form-label">{label}</label>
                  <input
                    type="number"
                    className="form-control"
                    value={form[key]}
                    onChange={set(key)}
                    step={step}
                    min={min}
                    required
                  />
                </div>
              ))}
              <div className="d-flex gap-2 justify-content-end mt-4">
                <button type="button" className="btn btn-outline-secondary" onClick={onClose}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary" disabled={saving}>
                  {saving ? 'Saving\u2026' : 'Save'}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
